import React from 'react';
import FlightMobile from './FlightMobile';
import FlightDesktop from './FlightDesktop';

const Operations = () => {
  return (
    <div>
      <div
        className={`hidden lg:flex flex-col
`}
      >
        <FlightDesktop />
      </div>
      <div className={`flex lg:hidden`}>
        <FlightMobile />
      </div>
    </div>
  );
};

export default Operations;
